import type { CatalogModel } from '@/lib/api/models'
import type { LibrarySketch } from '@/lib/canvas/shader/library'
import { createImageNode, createTextNode, createVideoNode, createNode3D } from '@/lib/canvas'
import { createShaderNode } from '@/lib/canvas/utils/nodeFactory'

export const LIBRARY_MODEL_DRAG_TYPE = 'library_model'
export const LIBRARY_SHADER_DRAG_TYPE = 'library_shader'
export type LibraryDropItem = { catalogModel: CatalogModel } | { librarySketch: LibrarySketch }

export function createLibraryNode(item: LibraryDropItem, position: { x: number; y: number }, canvasId: string | null) {
  if ('librarySketch' in item) {
    const sketch = item.librarySketch
    const node = createShaderNode(position)
    Object.assign(node.component.state, { canvasId, title: sketch.name, code: sketch.code, runtimeMode: sketch.runtimeMode, sketchId: sketch.id, extractedParams: sketch.params, paramValues: Object.fromEntries(sketch.params.map(p => [p.name, p.default])) })
    return node
  }
  const model = item.catalogModel
  const purpose = model.purpose === 'edit' || model.purpose === 'enhance' || model.purpose === 'tools' ? model.purpose : 'create'
  const node = model.nodeType === 'text-llm' ? createTextNode(position)
    : model.nodeType === 'video' ? createVideoNode(position, purpose)
    : model.nodeType === '3d' ? createNode3D(position, purpose)
    : createImageNode(position, purpose)
  Object.assign(node.component.state, { modelId: model.id, modelName: model.name, title: model.name, titleSource: 'automatic', canvasId })
  return node
}
